<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Formatters
	import { format } from 'svelte-i18n';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { isRgbwwPm, real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Alert, Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device;

	const deviceID = real_id(device.id);
	const isPro = isRgbwwPm(device.type);
	const component = isPro ? 'prorgbwwpm' : 'plusrgbwpm';
	const setConfigMethod = isPro ? 'ProRGBWWPM.SetConfig' : 'PlusRGBWpm.SetConfig';

	$: settingsStore = getDeviceSettings(deviceID);
	let settings = readDeviceSettings(deviceID);
	$: settings = $settingsStore ?? settings;

	let checked = settings?.[component]?.hf_mode;
	let waitingRorRequest = false;

	const sentRequests = async () => {
		checked = !checked;
		if (waitingRorRequest || checked == settings[component].hf_mode) return;
		waitingRorRequest = true;
		const enable = checked;
		const res: SettingRequest = await gen2Request(device, setConfigMethod, {
			id: device.channel,
			config: { hf_mode: enable },
		});
		if (res.isok) {
			settings[component].hf_mode = checked = enable;
			devices_settings.update_devices_settings(deviceID, settings);
		} else {
			checked = settings[component].hf_mode;
		}
		onSettingsResponse(res, device);
		waitingRorRequest = false;
	};
</script>

<Toggle {checked} size="m" on:click={sentRequests} id="toggle-uxav7t3">
	{capFirstChar(
		$format('enable', {
			default: 'Enable',
		}),
	)}
</Toggle>
<Alert
	class="mb-s"
	heading={$format('high_frequency_mode_desc', {
		default:
			'Increase PWM frequency to reduce the acoustic noise from the DC driver. This might cause non-precise colors in RGB/RGBW profiles when running at low brightness.',
	})}
/>
